import { Color } from '@tmh-website/shared/colors';
import StyledGlobal from '@tmh-website/styles/global';
import transparentize from 'polished/lib/color/transparentize';
import styled, { css } from 'styled-components';

export const Container = styled.a<{ ref?: any; $noHover?: boolean }>`
  position: relative;
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
  padding: 10px 16px;
  color: ${props => props.theme.color[Color.Blue_1000_Deep]};
  ${props => !props.$noHover && `cursor: pointer;`};
  transition: background-color ${props => props.theme.transitionTiming};
  @media (${props => props.theme.breakpoint.sm.up}) {
    padding: 10px ${props => props.theme.wrapperPaddingMobile};
  }
  @media (${props => props.theme.breakpoint.md.up}) {
    padding: 10px ${props => props.theme.wrapperPadding};
    border-radius: ${props => props.theme.borderRadius.small};
  }

  ${props =>
    !props.$noHover &&
    css`
      &:hover {
        text-decoration: none;
        background-color: ${props => props.theme.color[Color.Neutral_100]};
      }
    `};

  &:first-of-type {
    @media (${props => props.theme.breakpoint.sm.down}) {
      &::after {
        display: none;
        content: none;
      }
    }
  }

  &:last-of-type {
    @media (${props => props.theme.breakpoint.sm.up}) {
      &::after {
        display: none;
        content: none;
      }
    }
  }
`;

export const Title = styled.p`
  flex-grow: 1;
  max-width: 100%;
  margin: 0;
  overflow: hidden;
  font-weight: ${props => props.theme.fontWeight.semibold};
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (${props => props.theme.breakpoint.sm.down}) {
    flex-basis: 200px;
  }
`;

export const Type = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.2;
  color: ${props => transparentize(0.4, props.theme.color[Color.Blue_1000_Deep])};
  white-space: nowrap;
  @media (${props => props.theme.breakpoint.sm.down}) {
    flex-basis: auto;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media (${props => props.theme.breakpoint.sm.up}) {
    padding-left: 8px;
    border-left: 1px solid ${props => props.theme.color[Color.Neutral_500]};
  }
`;

export const FakeText = styled.div<{ $maxWidth: number }>`
  ${StyledGlobal.skeletonLoadingCss(Color.Neutral_200_OffWhite)};
  width: 100%;
  ${props => props.$maxWidth && `max-width: ${props.$maxWidth}px;`};
  height: 16px;
  margin: 4px 0;
  border-radius: ${({ theme }) => (theme.isBorderRadiusDisabled ? 0 : '2px')};
`;
